import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, searchType: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      return it[searchType].toLowerCase().includes(searchText);
    });
   }
}


// WEBPACK FOOTER //
// ./src/app/shared/_pipes/filter.pipe.ts